import React from 'react';
import { GOOGLE_REVIEWS_SEARCH_URL } from '../constants/googleReviewsUrl';
import { useStorefrontSettings } from '../context/StorefrontSettingsContext';
import {
  formatGoogleReviewStars,
  formatGoogleReviewSummary,
  useGoogleReviewsFeed,
} from '../hooks/useGoogleReviewsFeed';
import './GoogleAccreditationBanner.css';

const GoogleAccreditationBanner = () => {
  const { showGoogleReviewBadge } = useStorefrontSettings();
  const { rating, reviewCount, landingPageUrl, isLive, loaded } = useGoogleReviewsFeed();

  if (!showGoogleReviewBadge) return null;

  const summaryText = isLive
    ? formatGoogleReviewSummary(rating, reviewCount)
    : loaded
      ? 'Rating not available'
      : 'Loading Google reviews…';

  const starsDisplay = isLive ? formatGoogleReviewStars(rating) : '★★★★★';
  const href = landingPageUrl || GOOGLE_REVIEWS_SEARCH_URL;
  const className = `google-accreditation-banner${isLive ? ' google-accreditation-banner--live' : ' google-accreditation-banner--pending'}`;

  const content = (
    <>
      <span className="google-icon-span" aria-hidden="true">G</span>
      <span className="google-stars" aria-hidden="true">{starsDisplay}</span>
      <span className="google-text">{summaryText}</span>
    </>
  );

  if (isLive) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={`${className} google-accreditation-banner--link`}
        aria-label={`Google customer rating: ${summaryText}`}
      >
        {content}
      </a>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`${className} google-accreditation-banner--link`}
      aria-label="Google customer reviews"
    >
      {content}
    </a>
  );
};

export default GoogleAccreditationBanner;
